import { createSlice } from "@reduxjs/toolkit"

const serviceSlice = createSlice({
   name: "requests",
   initialState: {
      requests: [],
      isFetching: false,
      error: null,
   },
   reducers: {
      serviceStart: (state) => {
         state.isFetching = true
      },
      serviceFailure: (state, action) => {
         state.requests = []
         state.isFetching = false
         state.error = action.payload
      },
      getServiceSuccess: (state, action) => {
         state.requests = action.payload
         state.isFetching = false
         state.error = null
      },
      updateServiceSuccess: (state, action) => {
         state.requests[
            state.requests.findIndex((item) => item._id === action.payload.id)
         ] = action.payload.order
         state.isFetching = false
         state.error = null
      },
      deleteServiceSuccess: (state, action) => {
         state.requests.splice(
            state.requests.findIndex((item) => item._id === action.payload),
            1
         )
         state.isFetching = false
         state.error = null
      },
      createServiceSuccess: (state, action) => {
         state.isFetching = false
         state.error = null
         state.requests.push(action.payload)
      },
   },
})

export const {
   serviceStart,
   serviceFailure,
   getServiceSuccess,
   updateServiceSuccess,
   deleteServiceSuccess,
   createServiceSuccess,
} = serviceSlice.actions

export default serviceSlice.reducer
